import * as React from 'react';

import type { ClientBeneficiariesClient } from '@/api/clients-beneficiaries-client';
import { HttpClientBeneficiariesClient } from '@/api/clients-beneficiaries-client.http';

// =============================================================================
// clients-beneficiaries-client-context.tsx — Injection du ClientBeneficiariesClient (DI seam, S33).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle en prod) sans toucher
// l'UI. Contexte AUTO-PORTÉ par le BC client-reference : il n'est PAS branché dans providers.tsx global
// (surface partagée gelée) — le panneau `ClientsBeneficiariesPanel` enveloppe son contenu avec ce
// provider localement. Défaut = impl HTTP réelle (la feature est atteignable) ; les tests injectent le
// stub via la prop `client`.

const defaultClientBeneficiariesClient: ClientBeneficiariesClient =
  new HttpClientBeneficiariesClient();

const ClientBeneficiariesClientContext =
  React.createContext<ClientBeneficiariesClient>(defaultClientBeneficiariesClient);

export interface ClientBeneficiariesClientProviderProps {
  client?: ClientBeneficiariesClient | undefined;
  children: React.ReactNode;
}

export function ClientBeneficiariesClientProvider({
  client = defaultClientBeneficiariesClient,
  children,
}: ClientBeneficiariesClientProviderProps): React.JSX.Element {
  return (
    <ClientBeneficiariesClientContext.Provider value={client}>
      {children}
    </ClientBeneficiariesClientContext.Provider>
  );
}

export function useClientBeneficiariesClient(): ClientBeneficiariesClient {
  return React.useContext(ClientBeneficiariesClientContext);
}
